import { render } from "./TranslateLanguage.vue?vue&type=template&id=5c3fd8c2"
import script from "./TranslateLanguage.vue?vue&type=script&lang=js"
export * from "./TranslateLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__